<template>
  <section class="lets-chat d-flex align-items-center">
    <b-row class="w-100 m-0 justify-content-center">
      <b-col cols="10" sm="8" md="6" lg="5" xl="4" class="text-center p-0">
        <h2 class="title mb-5">{{ $t('enterprise.index.letsChat.title') }}</h2>
        <div class="button-container">
          <Button size="big" color="green" @click="$bvModal.show('contact-modal')">{{
            $t('enterprise.index.letsChat.btnText')
          }}</Button>
        </div>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import Button from 'UI/Button';

export default {
  name: 'LetsChat',
  components: {
    Button
  }
};
</script>

<style lang="scss" scoped>
.lets-chat {
  height: auto;
  padding: 50px 0;
  margin: 30px 15px 80px;
  @include md {
    min-height: 400px;
  }
  @include sm {
    min-height: 300px;
  }
  .title {
    color: #3e3e3e;
    font-size: 60px;
    @include md {
      font-size: 45px;
    }
    @include sm {
      font-size: 40px;
    }
  }
  .button-container {
    margin: auto;
    width: max-content;
  }
}
</style>
